import { mapToObj } from '../utils';
export const mergeInfniteMessagesData = (state, { messages = [], users = [], contacts = [], guests = [] }) => {
    const messagesById = mapToObj(messages, message => [message.id, message]);
    const usersById = mapToObj(users, user => [user.id, user]);
    const contactsById = mapToObj(contacts, contact => [contact.id, contact]);
    const guestsById = mapToObj(guests, guest => [guest.id, guest]);
    // map and update existing messages/users/contacts from payload
    const updatedPages = state.pages.map(page => ({
        messages: (page.messages || []).map(message => messagesById[message.id] || message),
        users: (page.users || []).map(user => usersById[user.id] || user),
        contacts: (page.contacts || []).map(contact => contactsById[contact.id] || contact),
        guests: (page.guests || []).map(guest => guestsById[guest.id] || guest),
    }));
    // flattened messages, contacts and users from all pages in the current state
    const flattenedState = state.pages.reduce((acc, page) => ({
        messages: [...(acc.messages || []), ...(page.messages || [])],
        users: [...(acc.users || []), ...(page.users || [])],
        contacts: [...(acc.contacts || []), ...(page.contacts || [])],
        guests: [...(acc.guests || []), ...(page.guests || [])],
    }), {
        messages: [],
        users: [],
        contacts: [],
        guests: [],
    });
    // messages that are not in the current state
    const newMessages = messages.filter(({ id }) => !(flattenedState.messages || []).some(m => m.id === id));
    // users that are not in the current state
    const newUsers = users.filter(({ id }) => !(flattenedState.users || []).some(u => u.id === id));
    // contacts that are not in the current state
    const newContacts = contacts.filter(({ id }) => !(flattenedState.contacts || []).some(c => c.id === id));
    // guests that are not in the current state
    const newGuests = guests.filter(({ id }) => !(flattenedState.guests || []).some(c => c.id === id));
    // append new messages/users/contacts to the first page
    const newLastPage = {
        messages: [...updatedPages[0].messages, ...newMessages],
        users: [...updatedPages[0].users, ...newUsers],
        contacts: [...updatedPages[0].contacts, ...newContacts],
        guests: [...updatedPages[0].guests, ...newGuests],
    };
    return {
        ...state,
        pages: [newLastPage, ...updatedPages.slice(1)],
    };
};
//# sourceMappingURL=queryHelpers.js.map